import { type FunctionComponent, type MouseEvent, type ReactNode } from 'react';
import classnames from 'classnames';
import { Link } from 'dibs-elements/exports/Link';

import styles from './styles/PageLinksPageItem.scss';

type PageLinksPageItemProps = {
    children: ReactNode;
    href?: string;
    isSelected?: boolean;
    onClick: (e: MouseEvent<HTMLElement>) => void;
    dataTn?: string;
};

const PageLinksPageItem: FunctionComponent<PageLinksPageItemProps> = ({
    children,
    href,
    isSelected,
    onClick,
    dataTn,
}: PageLinksPageItemProps) => {
    const undefinedPropControl: { href?: string } = {};
    if (href) {
        undefinedPropControl.href = href;
    }
    return isSelected ? (
        <span className={classnames(styles.item, styles.isSelected)} data-tn={dataTn}>
            {children}
        </span>
    ) : (
        <Link {...undefinedPropControl} className={styles.item} onClick={onClick} dataTn={dataTn}>
            {children}
        </Link>
    );
};

export { PageLinksPageItem };
